<template>
  <div>
    <!-- @page="pageClick"
      @sort="sortColumn" 
       :totalRecords="totalRecords"
      :lazy="(totalRecords != undefined && totalRecords > 0) ? true : false"
      :first="first"
      -->
    <DataTable
        :key="componentKeyW"
        :value="listDataService"
        :lazy="true"
        :class="'p-datatable-responsive p-datatable-table '+classDatatable"
        selectionMode="single"
        data-key="id"
        @page="onPage($event)"
        :paginator="pagination"
        :totalRecords="totalDataChange"
        :rows="paginationRows"
        :first="firstRecordIndex"
        :scrollable="(scrollHeightCustom !== '' ? true : false) "
        :scrollHeight="scrollHeightCustom"
        :autoLayout="true"
        filterMatchMode="startsWith"
        :rowsPerPageOptions="$dataCommon.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
        :currentPageReportTemplate=" $dataCommon.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
        :paginatorTemplate="$dataCommon.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
    ><!--:currentPageReportTemplate="'Tổng số: <b>' + totalDataChange + '</b> - Hiển thị:'"-->
      <Column  v-if="isCheckBox" selectionMode="multiple" headerStyle="width: 10rem"  :headerClass="'txt-center custom-header'" :header="headerCheckBox" :bodyClass="'txt-center'" :filterHeaderClass="'txt-center'">
      </Column>
      <Column  v-if="isExpand" :expander="true" headerStyle="width: 3rem" />
      <div v-if="model">
        <Column 
          v-for="c in listColumns"
          :key="c.key"
          :field="getField(c)"
          :header="getLabel(c)"
          :filterMatchMode="getFilterMatch(c)"
          :filterFunction="customFilter"
          :sortable="getSortable(c)"
          :bodyClass="(c.bodyClass ? c.bodyClass : (c.class ? 'txt-' + c.class : ''))"
          :bodyStyle="getHeaderStyle(c)"
          :headerStyle="getHeaderStyle(c)"
          :filterHeaderClass="(c.class ? 'txt-' + c.class : '')"
          :filterHeaderStyle="getHeaderStyle(c)"
          :headerClass="(c.headerClass ? c.headerClass : (c.class ? 'txt-' + c.class : ''))"
        >
          <template #body="slotProps" >
            <input :class="'checkbox-hidden'" :value="getConditionCheckbox(slotProps.data)"   v-if="isCheckBox" type="hidden" />
            <img
              v-if="getType(c) == 'Image'"
              :src="getData(c, slotProps.data)"
              style="width: 40px; heigth: 40px"
              v-on:click="callback(c, slotProps.data)"
            />
            <div
              v-else-if="c.type == 'Text'"
              v-html="getData(c, slotProps.data)"
              :style="(c.style ? c.style : '')"
              v-on:click="callback(c, slotProps.data)"
            ></div>
            <div
              v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
              v-html="getData(c, slotProps.data)"
              :style="(c.style ? c.style : '')"
              v-on:click="callback(c, slotProps.data)"
            ></div>

            <div
              v-else-if="(c.dataType !== undefined && c.dataType === 'Label')"
              v-html="getData(c, slotProps.data)"
            />
            <div
                v-else-if="getType(c) == 'Checkbox' || (c.dataType !== undefined && c.dataType === 'Checkbox')"
                v-on:click="callback(c, slotProps.data)"
            >
              <div
                  v-if="c.key_display_checkbox"
              >
                <Checkbox
                    v-if="slotProps.data[c.key_display_checkbox] == true"
                    v-model="slotProps.data[slotProps.column.field]"
                    :binary="true"
                    :disabled="(c.disabled !== undefined && c.dataType === 'Checkbox') ? c.disabled : false"
                />
                <div v-else></div>
              </div>
              <Checkbox
                  v-else
                  v-model="slotProps.data[slotProps.column.field]"
                  :binary="true"
                  :disabled="(c.disabled !== undefined && c.dataType === 'Checkbox') ? c.disabled : false"
              />
            </div>
            <!--<Checkbox
              v-else-if="getType(c) == 'Checkbox' || (c.dataType !== undefined && c.dataType === 'Checkbox')"
              v-model="slotProps.data[slotProps.column.field]"
              :binary="true"
              :disabled="(c.disabled !== undefined && c.dataType === 'Checkbox') ? c.disabled : false"
            />-->
            <div
                v-else-if="getType(c) == 'Select'"
            >
              <Dropdown
                  v-model="slotProps.data[slotProps.column.field]"
                  :options="getFilterOptions(c.key)"
                  :optionLabel="c.filter.optionLabel"
                  :optionValue="c.filter.optionKey"
                  :disabled="(c.disabled !== undefined) ? c.disabled : false"
                  :placeholder="getFilterPlaceHolder(c)"

              />
            </div>

            <span v-else  v-html="getData(c, slotProps.data)"  v-on:click="callback(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)+' '+getCustomClassColumnRow(c, slotProps.data[c.key], slotProps.data) "></span>
          </template>
          <template v-if="isFilter" #filter>
            <InputText
                v-if="c.filter != undefined && c.filter.type == 'input' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                type="text"
                v-model="filters[getField(c)]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
                @keyup="onFilter($event,c.filter.type,c.key)"
            />
            <Dropdown
                :key="countDropdown"
                v-if="c.filter != undefined && c.filter.type == 'select' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
                @change="onFilter($event,c.filter.type,c.key)"
                :style="getHeaderStyle(c)"
            >
              <template #option="slotProps">
                <div class="p-clearfix">
              <span
                  :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
              >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
                </div>
              </template>
            </Dropdown>

            <Calendar
                v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                :showOnFocus="false"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="1900:2500"
                dateFormat="dd-mm-yy"
                id="date_from"
                v-model="filters[getField(c)]"
                class="p-column-filter"
                :showIcon="true"
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                :showButtonBar="true"
                @clear-click="onFilter($event,c.filter.type,c.key)"
                @date-select="onFilter($event,c.filter.type,c.key)"
                :manualInput="true"
                :style="getHeaderStyle(c)"
            />
          </template>
        </Column>
        <Column
          v-if="actions"
          headerStyle="width: 10em; text-align: center"
          filterHeaderStyle="width: 10em; text-align: center"
          bodyStyle="width: 10em; text-align: center"
        >
          <template #body="slotProps">
            <span class="p-column-title">Actions</span>
            {{ slotProps.data.color }}
            <Button
              v-for="(a, k) in actions.rows(slotProps.data)"
              :key="k"
              type="button"
              :label="(a.isText != undefined && a.isText ? a.text : '')"
              :icon="getIcon(a.icon)"
              :class="getClass(a.name) + ' ' + (a.isText != undefined && a.isText ? 'tex-button' : '')"
              :disabled="getDisabled(a.disabled)"
              style="margin-right: 0.5em;"
              v-on:click="actionsClicked(k, a, slotProps)"
            ></Button>
          </template>
          <template #header="slotProps">
            <label class="label-header-action">{{labelHeaderAction }}</label>
            <Button
            :label=" (actions.header.label != undefined && actions.header.label  != '' ? actions.header.label : '')"
              v-if="actions.header"
              type="button"
              :icon="getIcon(actions.header.icon)"
              :class="getClass(actions.header.name)"
              v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
            > </Button>
          </template>
          <template v-if="actions.filter" #filter="slotProps">
            <span class="button-clear" v-if="actions.filter"  v-on:click="actionsClickedClear(actions.filter.name, actions.filter, slotProps)">Xóa bộ lọc</span>
            <!-- <img style="cursor: pointer;" width="25" :src="imgClear" v-if="actions.filter"  v-on:click="actionsClickedClear(actions.filter.name, actions.filter, slotProps)"/> -->
          </template>
        </Column>
        <ColumnGroup v-if="column_footer" type="footer">
          <Row v-for="row_footer in column_footer"  :key="row_footer.key">
            <Column v-for="col_footer in row_footer"  :key="col_footer.key" :colspan="col_footer.colspan" >
              <template #footer="{}" >
                <div
                    v-if="col_footer.type == 'Text'"
                    v-html="col_footer.value"
                    :style="(col_footer.style ? col_footer.style : '')"
                > <!--v-on:click="callback(c, slotProps.data)"-->
                  <!--{{col_footer}}-->
                </div>
              </template>
            </Column>
          </Row>
        </ColumnGroup>
      </div>
      <template #empty>
        Không có dữ liệu
      </template>
      <template #loading>
        Đang tải dữ liệu. Vui lòng chờ trong giây lát
      </template>
      <template #expansion="slotProps">
        <div class="table-subtable" v-if="slotProps.data">
          <h5 v-if="subtableTitle != ''" v-html="subtableTitle"></h5>
          <subTable
            :key="componentKeySubTable"
            :tableData="dataChanged[slotProps.data.id]"
            :model="subModel"
            :pagination="false"
          />
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import moment from 'moment'
import clearFilter from '../../../../../public/assets/images/clear-filter.png'
import subTable from '../../common/listSubTable'
export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    filterDefault: Object,
    scrollHeight: String,
    scrollable: Boolean,
    pagination: Boolean,
    globalFilterFields: Array,
    isFilter: Boolean,
    labelHeaderAction: String,
    isCheckBox: Boolean,
    headerCheckBox: String,
    isExpand: Boolean,
    subtableTitle: String,
    subModel: Object,
    subParams: Array,
    subOrderBy: String,
    classDatatable: String,
    dateType: Number,
    columnsDisplays: Array,
    totalRecords: Number,
    first: Number,
    countCheckBox: Boolean,
    arrCheckBoxHidden: Array,
    multiSortMeta: Array,
    column_footer: Array,
    map_custom_filter: Array,
  },
  components: {
    subTable
  },
  data() {
    return {
      imgClear: clearFilter,
      dataKey: (this.model.key.key !== undefined && this.model.key.key !== null && this.model.key.key !== '') ? this.model.key.key : 'id',
      filters: {},
      countDropdown: 0,
      loading: true,
      selectedRows: null,
      componentKey: 0,
      expandedRows: [],
      dataChanged: [],
      componentKeySubTable: Math.random() * 1203,
      lazyParams: {},
      optionsSub: [],
      listColumns: [],
      paginationRows: 10,
      rowsPerPageOptions: [10,20,50],
      totalRowsPage: 0,
      totalDataChange: 0,
      firstRecordIndex:0,
      totalRecordsL:0,
      listDataService:null,
      filtersCustom: [],
      scrollHeightCustom: '', // chiều cao của trang danh sách
      componentKeyW: 0,
    };
  },
  async created () {
    //console.log("scrollHeightscrollHeight:",this.scrollHeight)
    this.filters = this.filterDefault;
    if (localStorage.getItem('PAGINATION_ROWS') != undefined && localStorage.getItem('PAGINATION_ROWS') != null && !isNaN(localStorage.getItem('PAGINATION_ROWS'))) {
      this.paginationRows = parseInt(localStorage.getItem('PAGINATION_ROWS')) ;
    } else localStorage.getItem('PAGINATION_ROWS', this.paginationRows);
    if (localStorage.getItem('PAGINATION_ROWS_PAGE_OPTIONS') != undefined && localStorage.getItem('PAGINATION_ROWS_PAGE_OPTIONS') != null && localStorage.getItem('PAGINATION_ROWS_PAGE_OPTIONS') != '') {
      this.rowsPerPageOptions = localStorage.getItem('PAGINATION_ROWS_PAGE_OPTIONS').split(',').map(Number)
    } else localStorage.getItem('PAGINATION_ROWS_PAGE_OPTIONS', this.rowsPerPageOptions);
    this.loading = false;
    var that  = this;
    if (this.$myConstants.isEmpty(this.map_custom_filter["filter_data_range"]) ) {
      if (this.model) {
        //console.log("5555555555555555555555", this.columnsDisplays)
        this.listColumns = this.model.getDisplayFields();
        if (this.columnsDisplays && this.columnsDisplays.length) {
          this.listColumns = this.listColumns.filter(a => !that.columnsDisplays.includes(a.key))
        }
        this.totalDataChange = this.tableData.length;
        await this.processTotalRows(0);
      }
    }else {
      this.lazyParams = {
        first: 0,
        rows: this.paginationRows,
        sortField: null,
        sortOrder: null,
        filters: this.filters
      };
      if (!this.$myConstants.isEmpty(this.$route.query)){
        if (!this.$myConstants.isEmpty(this.$route.query.page_transaction)){
          this.page_transaction = this.$route.query.page_transaction;
          this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
          this.firstRecordIndex = this.lazyParams.first;
          // console.log("this.lazyParams:22222222",this.lazyParams);
          /*if (this.lazyParams){
            this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
          }*/
        }
      }
      if (!this.$myConstants.isEmpty(this.map_custom_filter["filter_data_range"]) ){
        this.filtersCustom = this.map_custom_filter;
        this.onLazyEvent(true);
      }
    }
    this.countCheckBoxOnTotal();
  },
  /*mounted () {
    this.countRows();
    this.countCheckBoxOnTotal();
  },*/
  mounted () {
   /* this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };*/
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    /*if (!this.$myConstants.isEmpty(this.$route.query)){
      if (!this.$myConstants.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /!*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*!/
      }
    }*/
    this.loading = false
    this.countDropdown++;
    /*if (!this.$myConstants.isEmpty(this.map_custom_filter["activation_date"]) ){
      this.filtersCustom = this.map_custom_filter;
      this.onLazyEvent();
    }*/
    this.countRows();
  },
  methods: {
    
    countCheckBoxOnTotal() {
      if (this.tableData && this.countCheckBox) {
        var item1 = document.getElementsByClassName("custom-header");
        if(item1.length > 0) {
          var length = (this.selectedRows != null) ? this.selectedRows.length : 0;
          item1[0].innerHTML = this.headerCheckBox + '<abbr>' + length + '/' + this.tableData.length + '</abbr';
        }
      }
    },
    processTotalRows(first) {
      var total = first + this.paginationRows;
      if (total > this.totalDataChange) {
        this.totalRowsPage = this.totalDataChange - first;
      } else this.totalRowsPage = this.paginationRows;
    },
    onPageClick(payload) {
      this.paginationRows = payload.rows;
      this.processTotalRows(payload.first);
    },
    callback(col, item) {
      if (col.callback !== undefined && col.callback) {
        this.$emit('callback', col, item)
      }
    },
    async onRowExpand(event) {
      var payloadData = event.data;
      var strVariable = '';
      if (this.subParams != null && Object.keys(this.subParams).length > 0) {
        for (let index = 0; index < this.subParams.length; index++) {
          const item = this.subParams[index];
          var value = (item.value != undefined && item.value != null ) ? item.value : (payloadData != null && item.field != undefined && payloadData[item.field] != undefined && payloadData[item.field] != null) ? payloadData[item.field]: '';
          if (value != '') strVariable += (strVariable.length > 0 ? ',' : '' ) + '"' + item.key + '": {"' + item.condition + '":' + value + '}';
        }
        if (strVariable.length > 0) {
          var strValue = strVariable;
          strVariable = '{';
          strVariable += '"where_key": {' + strValue + '}';
          if (this.subOrderBy != undefined && this.subOrderBy != null && this.subOrderBy.length > 0) {
            strVariable += ',"orderBy": {' + this.subOrderBy + '}';
          }
          strVariable += '}';
        } else  {
          if (this.subOrderBy != undefined && this.subOrderBy != null && this.subOrderBy.length > 0) {
            strVariable = '{ "orderBy" : {' + this.subOrderBy + '} }';
          }
        }
        var data = await DataServices.getList(this.subModel.name, {"variables": strVariable});
        var list = data[Object.keys(data)];
        this.subModel.processData(list);
        this.dataChanged[payloadData.id] = list;
        this.componentKeySubTable = Math.random() * 302;
      }
    },
    async onRowCollapse(payload) {
      this.dataChanged[payload.data.id] = [];
    },
    allRowsSelected() {
      this.countCheckBoxOnTotal();
      this.$emit('row-select-all', this.selectedRows);
    },
    rowsSelected() {
      this.countCheckBoxOnTotal();
      this.$emit('row-select', this.selectedRows);
    },
    filterRowsData(payload) {
      this.totalDataChange = payload.filteredValue.length;
      this.processTotalRows(payload.first);
      this.$emit('filter', payload);
      this.countRows();
    },
    selectChangeDate(event, col, type = '') {
      console.log("eventeventevent:",event)
      this.$emit("filter_date", {
        data: event,
        col: col,
        type: type,
        format: this.formatDate('Date')
      });
      this.countRows();
    },
    clearChangeDate(col, type = '') {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (type == '') delete this.filters[this.getField(col)];
        else if (type != '' && date[type] != undefined && date[type] != null) delete this.filters[this.getField(col)][type];
      }
      this.$emit("filter_date", {
        col: col,
        type: type
      });
      this.countRows();
    },
    getValueDateRange(col, target) {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (target != '') {
          if (date[target] != undefined && date[target] != null) {
            return moment(date[target]).format(this.formatDate('Date'));
          }
        } else return moment(date).format(this.formatDate('Date'));
      }
      return null;
    },
    getLabel(col) {
      if (col.label) return  col.label;
      else return col.name;
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getCustomClassColumnRow(col, data, rowData) {
      if (rowData.customClass){
        if (rowData.customClass.length > 0){
          for (var i=0;i<rowData.customClass.length;i++){
            if (rowData.customClass[i].column == col.key ){
              return (rowData.customClass[i].class) ? rowData.customClass[i].class:''
            }
          }
        }
      }
       return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    formatDate(type) {
      var value = '';
      if (type == "Date") {
        value = "DD/MM/yyyy";
      } else if (type == "Datetime") {
        value = "hh:mm:ss DD/MM/yyyy";
      } else if (type == "CustomDate") {
        value ="hh:mm - DD/MM/yyyy";
      } else if (type == "CustomDateTime") {
        value ="DD/MM/yyyy hh:mm";
      } else if(type == "Hour"){
        value = "hh:mm";
      }
      return value
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        // value =  moment.utc(row[col.key]).local().format('DD/MM/YYYY');
        value = moment.tz(row[col.key], this.$myConstants.timeZone()).format('DD/MM/YYYY');
      } else if (col.type == "Datetime" && row[col.key]) {
        // value =  moment.utc(row[col.key]).local().format('HH:mm:ss DD/MM/YYYY');
        value = moment.tz(row[col.key], this.$myConstants.timeZone()).format('HH:mm:ss DD/MM/YYYY');
      } else if (col.type == "CustomDateTime" && row[col.key]) {
        // value =  moment.utc(row[col.key]).local().format('DD/MM/YYYY HH:mm');
        value = moment.tz(row[col.key], this.$myConstants.timeZone()).format('DD/MM/YYYY HH:mm');
      } else if (col.type == "CustomDate" && row[col.key]) {
        // value =  moment.utc(row[col.key]).local().format('HH:mm - DD/MM/YYYY');
        value = moment.tz(row[col.key], this.$myConstants.timeZone()).format('HH:mm - DD/MM/YYYY');
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.$myConstants.timeZone()).format('HH:mm');
        // value = moment.utc(row[col.key]).local().format('HH:mm');
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            var returnItem = objResult[Object.keys(objResult)];
            value = this.conditionDisplay(col, returnItem)
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key];//.substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        else if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        else if (this.getType(col) == "Number") {
          if (col.dataType != undefined &&  col.dataType == "Custom") {
            var valueFormat = this.$myConstants.shortenLargeNumber(row[col.key], 'k');
            value = (col.linkCustom != undefined) ? col.linkCustom.replace('{0}', valueFormat) : valueFormat; 
          }
          else value = this.$myConstants.formatThousand(row[col.key]);
        }
        else value = row[col.key];
      }
      if (col.style && value != undefined) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (col.dataType == 'Label' && Object.keys(filtered) && Object.entries(filtered).length) {
          if (filtered[0].style && value != undefined) value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
          else value = filtered[0][col.filter.optionLabel];
        } else if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style && value != undefined) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    conditionDisplay(col, row) {
      if (col.whereFormat !== undefined && col.whereFormat !== null) {
        for (let index = 0; index < col.whereFormat.length; index++) {
          var ele = col.whereFormat[index];
          if (row.item !== undefined && row.item[ele.key] !== undefined && ele.value === row.item[ele.key]) {
            return '<abbr class="'+ ele.class+ '">' + row.label + '</abbr>';
          } else return row.label;
        }
      }
      return row.label;
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    customFilter( itemLabel, filterValue) {
      var checkCondition = true;
      var checkInput = true;
      if (this.dateType > 0) {
        if (this.dateType == 1) {
          if (filterValue == undefined) return true;
          var date1 = new Date(moment(itemLabel).format('YYYY-MM-DD'));
          var date2 = new Date(moment(filterValue).format('YYYY-MM-DD'));
          checkCondition = Number(date1) == Number(date2);
        } else if (this.dateType == 2) {
          var date3 = new Date(moment(itemLabel).format('YYYY-MM-DD'));
          if (filterValue != undefined && filterValue.from != undefined && filterValue.from != null && filterValue.to != undefined && filterValue.to != null) {
            var valueFrom = new Date(moment(filterValue.from).format('YYYY-MM-DD'));
            var valueTo = new Date(moment(filterValue.to).format('YYYY-MM-DD'));
            checkCondition = Number(date3) >= Number(valueFrom) && Number(date3) <= Number(valueTo);
          } else if (filterValue != undefined && filterValue.from != undefined && filterValue.from != null) {
            var dateFrom = new Date(moment(filterValue.from).format('YYYY-MM-DD'));
            checkCondition = Number(date3) >= Number(dateFrom);
          } else if (filterValue != undefined && filterValue.to != undefined && filterValue.to != null) {
            var dateTo = new Date(moment(filterValue.to).format('YYYY-MM-DD'));
            checkCondition = Number(date3) <= Number(dateTo);
          }
        }
      }
      if (filterValue != '' && typeof filterValue != 'object' && itemLabel != undefined) {
        var labelData = itemLabel.trim().toLowerCase();
        var labelFilter = filterValue.trim().toLowerCase();
        labelData = this.$myConstants.cleanAccents(labelData, '');
        labelFilter = this.$myConstants.cleanAccents(labelFilter, '');
        checkInput  = itemLabel.indexOf(filterValue) >= 0 || labelData.indexOf(labelFilter) >= 0;
      }
      if (itemLabel == undefined || itemLabel == '') {
        checkCondition = false;
        checkInput = false
      }
     
      return checkCondition && checkInput;
    },
    getFilterPlaceHolder(col) {
      if (col.filter != undefined && col.filter.placeHolder != undefined) {
        return col.filter.placeHolder;
      } else if (col.filter != undefined && col.filter.type != undefined && col.filter.type == "select") {
        if (!this.$myConstants.isEmpty(col.filter.placeHolder)){
          return col.filter.placeHolder;
        }else {
          return (col.filter != undefined && col.filter.display != undefined &&  col.filter.display !== undefined && !col.filter.display) ? `Tất cả` : `Chọn ${this.getLabel(col)}`;
        }
      } else if (col.filter.type != undefined &&  col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData
      });
    },
    actionsClickedClear() {
      this.filters = {};
      this.$emit('clear-click');
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
        case "clear":
          return "p-button-danger";
      }
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    filterData(event) {
      // console.log('filter', event)
      this.$emit('filter', event);
    },
    getConditionCheckbox(row) {
      if (this.arrCheckBoxHidden != undefined & this.arrCheckBoxHidden != null) {
        var classHidden = 'checkbox';
        for (let index = 0; index < this.arrCheckBoxHidden.length; index++) {
          var field = this.arrCheckBoxHidden[index];
          classHidden += '-' + row[field];
        }
        return classHidden;
      }
    },
    countRows() {
      var item = null;
      if (!this.$myConstants.isEmpty(this.classDatatable)){

         item = document.querySelector("."+this.classDatatable+" .p-paginator-current");
        console.log("itemitemitem:",item)
        if(item) {

          item.innerHTML = 'Tổng số: <b>' + this.totalDataChange + '</b> - Hiển thị:';
        }
      }else {
         item = document.getElementsByClassName("p-paginator-current");
        console.log("33333333")
        if(item.length > 0) {
          console.log("66666666666666")
          item[0].innerHTML = 'Tổng số: <b>' + this.totalDataChange + '</b> - Hiển thị:';
        }
      }
    },
    // pageClick(event) {
    //   console.log('sdddddd', event)
    //   this.$emit('page-click', event.originalEvent);
    // },
    // sortColumn(event) {
    //   var column = event.sortField;
    //   var sort = event.sortOrder;
    //   this.lazyParams['sortField'] = {name: column, direction: sort}
    //   const hasKey = this.lazyParams.hasOwnProperty('sortField');
    //   if(hasKey) {

    //   }
    // },
    changeText() {
      // console.log('changeText', event, col, this.filters)
    },
    // selectChangeDate1(event, col, type = '') {
    //   this.$emit("filter_date", {
    //     data: event,
    //     col: col,
    //     type: type,
    //     format: this.formatDate('Date')
    //   });
    // },
    dropdownChange() {
      //console.log('dropdownChange', col, event, this.filters)
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    onLazyEvent(is_refesh_table=false) {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that =this;
      this.dataList(this.lazyParams).then(async data => {

        var variables_service_unit = {
          where_key: {},
          orderBy: {"code": "desc"}
        }
        var list_service_unit = await DataServices.getListData('service_unit', {"variables": JSON.stringify(variables_service_unit)});
        var map_service_unit = {};
        for (var s=0;s<list_service_unit.length;s++){
          map_service_unit[list_service_unit[s].code] = (!that.$myConstants.isEmpty(list_service_unit[s].name)) ? list_service_unit[s].name:'';
        }

        var list_data = data.listData;
        for (var k=0;k<list_data.length;k++){
          var unit_service = (!that.$myConstants.isEmpty(list_data[k].obj_service_supplies)) ? list_data[k].obj_service_supplies.unit:'';
          list_data[k].unit_text = (!that.$myConstants.isEmpty(map_service_unit[unit_service])) ? map_service_unit[unit_service]:'';
        }
        this.listColumns = DataServices.getModel('report_service_supplies');
        this.listColumns.processData(list_data);
        this.listColumns =this.listColumns.getDisplayFields();
        if (this.columnsDisplays && this.columnsDisplays.length) {
          this.listColumns = this.listColumns.filter(a => !that.columnsDisplays.includes(a.key))
        }
        /*var action_tmp = that.$myConstants.convertJsonObject(that.actions);
        that.actions = null;
        that.actions = action_tmp;*/
        that.listDataService = list_data;
        this.totalDataChange = data.total;
        if (is_refesh_table == true){
          this.componentKeyW++;
        }
        this.countRows();
        //that.totalRecordsL = data.total;
        that.loading = false;
      });
    },
    async dataList(lazyParams) {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      var vm = this;
      var modelName = 'report_service_supplies';
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      var where = {obj_product_sn_has_service_park: {obj_warranty_repair_product: {process_status: {_eq: vm.$dataCommon.WARRANTY_REPAIR.PRODUCT_STATUS.MADE}}}}
      var filters = lazyParams.filters;
      if (filters){
        for (const [key, value] of Object.entries(filters)) {
           if (!this.$myConstants.isEmpty(value.value)){
             switch(value.type_input) {
               /*case 'input':
                 if (key == 'input_work_order'){
                   if (this.$myConstants.isEmpty(where['serial_number'])){
                     where['serial_number'] = {};
                   }
                   where["serial_number"]["production_order_code"] = {_like: "%"+value.value.trim()+"%"};//this.$myConstants.SkipVN()
                 }
                 break;*/
               case 'DateRange':
                 if (key=='filter_data_range'){
                   where['modified_date'] = {'_gte': value.value.from,'_lte': value.value.to}
                 }else {
                   where[key] = {'_gte': value.value.from,'_lte': value.value.to}
                 }
                 break;
               case 'MultiSelect':
                 if (key == 'selected_organization_filter'){
                      if (value.value.length > 0){
                        where['modified_organization_id'] = {_in: value.value}
                      }
                 }
                 else if (key == 'selected_service_supplies'){
                   if (value.value.length > 0){
                     where['service_supplier_id'] = {_in: value.value}
                   }
                 }
                 //organizations: {province_id: {_in: 10}}}
                 //console.log("value.value:",value.value)
                 /*if(value.value !== undefined && value.value !== null){
                   where[key] = {'_gte': value.value.from,'_lte': value.value.to}
                 }*/
                 break;
               default:
                 // code block
             }
         }
        }
      }
      var variables = {
        where_key: where,
        offset:offset,
        limit:limit,
        orderBy: [
          {id: 'desc'},
         // {parts_number: 'desc'}
        ]
      }
      this.$emit('filterExport',variables)//truyền query
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      var variablesCount = {
        where_key: where
      }
      var name_aggregate = 'core_warranty_repair_product_sn_has_service_supplies_aggregate';
      var countDataQuery = await DataServices.countData(modelName, {"variables": JSON.stringify(variablesCount)});
      var total = countDataQuery[name_aggregate]['aggregate']['count'];
      var dataRes = {
        listData: list,
        total: total,
      };
      this.$store.commit('setLoading', false);
      //  console.log('dataRes:',dataRes);
      return dataRes;
    },
    async onFilter(event,type_input,key) {
      this.filtersCustom[key] = await this.$coreService.convertFilter(type_input,key,this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
    sortTable(event) {
      console.log("eventevent:",event)
      var sortby = 'asc'
      this.orderBy = {}
      if(event.sortOrder == -1){
        sortby = 'desc'
      }
      //if (event.sortField == 'created_at'){
      //Nếu ngày tạo thì sort id chính xác hơn
      this.orderBy[event.sortField] = sortby
      // }
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
  }
};
</script>
<style >
.p-datatable .p-sortable-column .p-sortable-column-badge{
  text-align: center;
}
</style>